import { render } from "./select.vue?vue&type=template&id=36096a11&lang=pug"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"
script.render = render

export default script